import { lazy } from "react";
import { useTranslation } from "react-i18next";
import ICarouselSlide from "../../components/carousel/ICarouselSlide";

const Carousel = lazy(() => import(/* webpackChunkName: "page-section-module" */ "../../components/carousel/Carousel"));

export default function HomeCarousel() {
    const { t } = useTranslation("home");

    const slides: ICarouselSlide[] = [
        {
            header: `${t("carousel.slides.who.pill")}`,
            title: `${t("carousel.slides.who.title")}`,
            description: `${t("carousel.slides.who.description")}`,
            image: {
                url: "/img/home/img-vertical.webp",
                altText: `${t("carousel.slides.who.title")}`
            },
            details: t('carousel.slides.who.details', { returnObjects: true }) as string[]
        },
        {
            header: `${t("carousel.slides.support.pill")}`,
            title: `${t("carousel.slides.support.title")}`,
            description: `${t("carousel.slides.support.description")}`,
            image: {
                url: "/img/home/img-horizontal.webp",
                altText: `${t("carousel.slides.support.title")}`
            },
            details: t('carousel.slides.support.details', { returnObjects: true }) as string[]
        },
        {
            header: `${t("carousel.slides.migrate.pill")}`,
            title: `${t("carousel.slides.migrate.title")}`,
            description: `${t("carousel.slides.migrate.description")}`,
            image: {
                url: "/img/home/img-horizontal2.webp",
                altText: `${t("carousel.slides.migrate.title")}`
            },
            details: t('carousel.slides.migrate.details', { returnObjects: true }) as string[]
        }
    ];

    return <Carousel slides={slides} />
}